module.exports = __webpack_public_path__ + "img/158.2bb8e35d.jpg";